import { render } from "./CheckoutFinalStep.vue?vue&type=template&id=68fbf22a"
import script from "./CheckoutFinalStep.vue?vue&type=script&lang=js"
export * from "./CheckoutFinalStep.vue?vue&type=script&lang=js"

import "./CheckoutFinalStep.vue?vue&type=style&index=0&id=68fbf22a&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front-twint-ux/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__